<template>
  <collapsible-widget
    title="UMIEŚĆ OBIEKT"
    :minHeight="40"
    flex="1"
    :accordion="accordion"
    :default-expanded="true"
  >
    <b-form id="set-object-form">
      <b-form-group class="mt-2">
        <b-alert class="m-2" :show="noFeaturesSelected" variant="primary">
          <strong>Informacja.</strong> Aby aktywować narzędzie należy wybrać
          obiekt do wprowadzenia współrzędnych.
        </b-alert>
        <b-alert class="m-2" :show="tooManyFeaturesSelected" variant="primary">
          <strong>Informacja.</strong> Wybrano więcej niż jeden obiekt.
          Narzędzie umożliwia wprowadzenie współrzędnych tylko jednego obiektu.
          Aby aktywować narzędzie zaznacz dokładnie jeden obiekt.
        </b-alert>
      </b-form-group>
      <div v-if="showSetGeometryTool">
        <b-form-group
          label="Długość geograficzna"
          label-for="newPointX"
          label-size="sm"
        >
          <b-row v-show="xCoordinateInvalid">
            <b-col>
              <small class="text-danger">Wartość niepoprawna.</small>
            </b-col>
          </b-row>
          <b-form-input
            id="newPointX"
            size="sm"
            v-model.number="newPoint.x"
            placeholder="Wpisz długość geograficzną"
            type="number"
            :state="xCoordinateInvalid ? false : null"
          ></b-form-input>
        </b-form-group>
        <b-form-group
          label="Szerokość geograficzna"
          label-for="newPointY"
          label-size="sm"
        >
          <b-row v-show="yCoordinateInvalid">
            <b-col>
              <small class="text-danger">Wartość niepoprawna.</small>
            </b-col>
          </b-row>
          <b-form-input
            id="newPointY"
            size="sm"
            v-model.number="newPoint.y"
            placeholder="Wpisz szerokość geograficzną"
            type="number"
            :state="yCoordinateInvalid ? false : null"
          ></b-form-input>
        </b-form-group>
        <b-form-row>
          <b-col>
            <b-button
              class="btn-block"
              size="sm"
              variant="primary"
              @click="save"
              title="Zapisz"
              >Zapisz</b-button
            >
          </b-col>
          <b-col>
            <b-button
              class="btn-block"
              size="sm"
              variant="primary"
              @click="appendPoint"
              title="Dodaj punkt"
              >Dodaj punkt</b-button
            >
          </b-col>
          <b-col>
            <b-button
              class="btn-block"
              size="sm"
              variant="outline-secondary"
              @click="endDrawing"
              title="Anuluj"
              >Anuluj</b-button
            >
          </b-col>
        </b-form-row>
      </div>
    </b-form>
    <div id="geometry-table" class="p-2" v-if="showSetGeometryTool">
      <table class="table table-sm">
        <thead>
          <tr>
            <th v-if="geometryType != 'Point'"><small>lp.</small></th>
            <th><small>Długość geograficzna</small></th>
            <th><small>Szerokość geograficzna</small></th>
            <th v-if="geometryType != 'Point'"></th>
          </tr>
        </thead>
        <tbody v-if="geometryType == 'LineString'">
          <tr v-for="(coordinate, index) in coordinates" :key="index">
            <td>{{ index + 1 }}</td>
            <td>
              <b-input
                size="sm"
                v-model.number="coordinate[0]"
                type="number"
                @change="changedGeometry(index)"
              ></b-input>
            </td>
            <td>
              <b-input
                size="sm"
                v-model.number="coordinate[1]"
                type="number"
                @change="changedGeometry(index)"
              ></b-input>
            </td>
            <td>
              <a href="#" title="Usuń" @click.prevent.stop="deletePoint(index)">
                <icon name="trash"></icon>
              </a>
            </td>
          </tr>
        </tbody>
        <tbody v-else-if="geometryType == 'Polygon'">
          <tr v-for="(coordinate, index) in coordinates[0]" :key="index">
            <td>{{ index + 1 }}</td>
            <td>
              <b-input
                size="sm"
                v-model.number="coordinate[0]"
                type="number"
                @change="changedGeometry(index)"
              ></b-input>
            </td>
            <td>
              <b-input
                size="sm"
                v-model.number="coordinate[1]"
                type="number"
                @change="changedGeometry(index)"
              ></b-input>
            </td>
            <td>
              <a href="#" title="Usuń" @click.prevent.stop="deletePoint(index)">
                <icon name="trash"></icon>
              </a>
            </td>
          </tr>
        </tbody>
        <tbody v-else-if="geometryType == 'Point'">
          <tr>
            <td>
              <b-input
                size="sm"
                v-model.number="coordinates[0]"
                type="number"
                @change="changedGeometry()"
              ></b-input>
            </td>
            <td>
              <b-input
                size="sm"
                v-model.number="coordinates[1]"
                type="number"
                @change="changedGeometry()"
              ></b-input>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </collapsible-widget>
</template>

<script>
import { mapGetters } from 'vuex';
import CollapsibleWidget from './CollapsibleWidget';

import {
  SET_FEATURE_SAVE_GEOMETRY,
  END_SET_FEATURE_GEOMETRY
} from '../store/actions.type';
import {
  SET_FEATURE_GEOMETRY_READY,
  SET_FEATURE_GEOMETRY_FEATURE_ADD_POINT_MANUALLY,
  SET_FEATURE_GEOMETRY_POINT_CHANGED,
  SET_FEATURE_GEOMETRY_FEATURE_DELETE_POINT
} from '../store/mutations.type';

export default {
  name: 'SetFeatureGeometryTool',
  props: {
    accordion: {
      type: String,
      default: 'panel'
    }
  },
  computed: {
    ...mapGetters(['setFeatureGeometryDrawnFeature', 'selectedMapFeatures']),
    tooManyFeaturesSelected() {
      return this.selectedMapFeatures.size > 1;
    },
    noFeaturesSelected() {
      return this.selectedMapFeatures.size == 0;
    },
    exactlyOneFeatureSelected() {
      return this.selectedMapFeatures.size == 1;
    },
    showSetGeometryTool() {
      return this.exactlyOneFeatureSelected;
    },
    xCoordinateInvalid() {
      return (
        this.dirty &&
        (this.newPoint.x == '' ||
          this.newPoint.x == null ||
          this.newPoint.x == undefined)
      );
    },
    yCoordinateInvalid() {
      return (
        this.dirty &&
        (this.newPoint.y == '' ||
          this.newPoint.y == null ||
          this.newPoint.y == undefined)
      );
    }
  },
  components: {
    CollapsibleWidget
  },
  data() {
    return {
      coordinates: [],
      newPoint: { x: null, y: null },
      dirty: false,
      geometryType: null
    };
  },
  methods: {
    async appendPoint() {
      this.dirty = true;
      if (this.validateNewPointCoordinates()) {
        await this.$store.commit(
          SET_FEATURE_GEOMETRY_FEATURE_ADD_POINT_MANUALLY,
          [this.newPoint.x, this.newPoint.y]
        );
        this.newPoint.x = this.newPoint.y = null;
        this.dirty = false;
      }
    },
    async changedGeometry(index) {
      await this.$store.commit(SET_FEATURE_GEOMETRY_POINT_CHANGED, {
        index: index,
        coordinates: this.coordinates
      });
    },
    async deletePoint(index) {
      await this.$store.commit(
        SET_FEATURE_GEOMETRY_FEATURE_DELETE_POINT,
        index
      );
    },
    endDrawing() {
      this.$store.dispatch(END_SET_FEATURE_GEOMETRY);
    },
    validateNewPointCoordinates() {
      return !this.xCoordinateInvalid && !this.yCoordinateInvalid;
    },
    onFeatureChanged(evt) {
      this.geometryType = evt.target.getGeometry().getType();
      this.coordinates = evt.target.getGeometry().getCoordinates();
    },
    async save() {
      await this.$store.dispatch(SET_FEATURE_SAVE_GEOMETRY);
    }
  },
  mounted() {
    if (this.setFeatureGeometryDrawnFeature) {
      this.setFeatureGeometryDrawnFeature.on('change', this.onFeatureChanged);
    }
  },
  watch: {
    setFeatureGeometryDrawnFeature(value) {
      if (value == null || value == undefined) {
        this.coordinates = [];
      } else {
        this.coordinates = this.setFeatureGeometryDrawnFeature
          .getGeometry()
          .getCoordinates();
        this.setFeatureGeometryDrawnFeature.on('change', this.onFeatureChanged);
      }
    },
    exactlyOneFeatureSelected(value) {
      this.$store.commit(SET_FEATURE_GEOMETRY_READY, value);
    }
  }
};
</script>

<style>
#set-object-form {
  padding-left: 1em;
  padding-right: 1em;
}
</style>
